import React from 'react';
import styles from './CansContainer.module.css';
import Cans from '../cans/Cans';

import orangecan from '../../assets/orange-can.png';
import orangefruit1 from '../../assets/orange-fruit-1.png';
import orangefruit2 from '../../assets/orange-fruit-2.png';

import purplecan from '../../assets/purple-can.png';
import purplefruit1 from '../../assets/purple-fruit-1.png';
import purplefruit2 from '../../assets/purple-fruit-2.png';

import yellowcan from '../../assets/yellow-can.png';
import yellowfruit1 from '../../assets/yellow-fruit-1.png';
import yellowfruit2 from '../../assets/yellow-fruit-2.png';

import redcan from '../../assets/red-can.png';
import redfruit1 from '../../assets/red-fruit-1.png';
import redfruit2 from '../../assets/red-fruit-2.png';

const CansContainer = () => {
    return(
        <div className={styles.banner_bottom_mobile}>
                <Cans can={orangecan} fruit1={orangefruit1} fruit2={orangefruit2} inner={{background: "#EA7D1A26"}} outer={{background: "#EA7D1A14"}} />
                <Cans can={purplecan} fruit1={purplefruit1} fruit2={purplefruit2} inner={{background: "#A954DD1F"}} outer={{background: "#A954DD12"}} />
                <Cans can={yellowcan} fruit1={yellowfruit1} fruit2={yellowfruit2} inner={{background: "#F2CB4940"}} outer={{background: "#F2CB4926"}} />
                <Cans can={redcan} fruit1={redfruit1} fruit2={redfruit2} inner={{background: "#DB1A1D21"}} outer={{background: "#DB1A1D14"}} />
            </div>
    )
}

export default CansContainer;